import { IPointsOfSaleStateInitialState } from 'interfaces/pointsOfSale.interface';
import * as PointsOfSaleType from './pointsOfSale.types';
import { IPointOfSaleState } from 'api/endpoints/pointsOfSale/pointsOfSale.response.interface';

export type TpointsOfSaleDispatchReducer =
  | {
      type: typeof PointsOfSaleType.GET_POINTS_OF_SALE;
      payload: Array<IPointOfSaleState>;
    }
  | {
      type: typeof PointsOfSaleType.IS_LOADING_GET_POINTS_OF_SALE;
      payload: boolean;
    }
  | {
      type: typeof PointsOfSaleType.SELECT_POINT_OF_SALE;
      payload: IPointOfSaleState | null;
    }
  | {
      type: typeof PointsOfSaleType.CREATE_POINT_OF_SALE;
      payload: IPointOfSaleState;
    }
  | {
      type: typeof PointsOfSaleType.UPDATE_POINT_OF_SALE;
      payload: {
        pointOfSaleId: string;
        pointOfSale: Partial<IPointOfSaleState>;
      };
    }
  | {
      type: typeof PointsOfSaleType.REMOVE_POINT_OF_SALE;
      payload: string;
    };

export default function pointsOfSaleReducer(
  state: IPointsOfSaleStateInitialState,
  action: TpointsOfSaleDispatchReducer
) {
  const { type, payload } = action;

  switch (type) {
    case PointsOfSaleType.GET_POINTS_OF_SALE: {
      const getPointsOfSale: IPointsOfSaleStateInitialState = {
        ...state,
        pointsOfSale: payload,
      };
      return getPointsOfSale;
    }

    case PointsOfSaleType.IS_LOADING_GET_POINTS_OF_SALE: {
      const isLoadingGetPointsOfSale: IPointsOfSaleStateInitialState = {
        ...state,
        isLoadingGetPointsOfSale: payload,
      };
      return isLoadingGetPointsOfSale;
    }

    case PointsOfSaleType.SELECT_POINT_OF_SALE: {
      const selectPointOfSale: IPointsOfSaleStateInitialState = {
        ...state,
        pointsOfSaleSelected: payload,
      };
      return selectPointOfSale;
    }

    case PointsOfSaleType.CREATE_POINT_OF_SALE: {
      const createPointOfSale: IPointsOfSaleStateInitialState = {
        ...state,
        pointsOfSale: [...state.pointsOfSale, payload],
      };
      return createPointOfSale;
    }

    case PointsOfSaleType.UPDATE_POINT_OF_SALE: {
      const updatePointOfSale: IPointsOfSaleStateInitialState = {
        ...state,
        pointsOfSale: state.pointsOfSale.map((pointOfSale: IPointOfSaleState) =>
          pointOfSale.id === payload.pointOfSaleId
            ? { ...pointOfSale, ...payload.pointOfSale }
            : pointOfSale
        ),
        pointsOfSaleSelected: null,
      };
      return updatePointOfSale;
    }

    case PointsOfSaleType.REMOVE_POINT_OF_SALE: {
      const removePointOfSale: IPointsOfSaleStateInitialState = {
        ...state,
        pointsOfSale: state.pointsOfSale.filter(
          (pointOfSale) => pointOfSale.id !== payload
        ),
      };
      return removePointOfSale;
    }

    default:
      return state;
  }
}
